import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	UserPatchRequest as Req,
	UserPatchResponse as Res,
} from "src/business.InterfaceLayer/store/entities/auth.entity/redux/api/types/PATCH";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import AUTH_PATHS from "../../paths";

const patchRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.PATCH,
	MAIN_PATHS.AUTHORIZATION
);

const authApiPatchQueries = (build: ApiQueryBuilder) => ({
	patchRecoveryPassword: build.mutation<
		Res.PatchRecoveryPassword,
		Req.PatchRecoveryPassword
	>({
		query: (body) => ({
			...patchRequestBaseDefinition({
				path: AUTH_PATHS.EDIT_PASSWORD,
			}),
			body,
		}),
	}),
});

export default authApiPatchQueries;
